<template>
  <footer class="app-footer">
    <div class="footer-copyright">© Swoop {{ year }}</div>

    <div class="footer-links">
      <a v-if="portalConfig.showSwoopWebsiteLink" :href="portalConfig.swoopMarketingUrl" rel="noopener" target="_blank" class="footer-link">Swoop Website</a>
      <a :href="globalConfig.privacyPolicyUrl" rel="noopener" target="_blank" class="footer-link">Privacy Policy</a>
      <a :href="globalConfig.termsAndConditionsUrl" rel="noopener" target="_blank" class="footer-link">Terms &amp; Conditions</a>
    </div>

    <div v-if="signInConfig.showPoweredBySwoop" class="footer-powered-by">
      <span class="powered-by-text">Powered by</span>
      <img :src="swoopLogoUrl" alt="Swoop" class="powered-by-logo" />
    </div>
  </footer>
</template>

<script>
import useWhitelabel from '@/composables/useWhitelabel'
import swoopLogoUrl from '@/assets/images/logo.svg?url'

export default {
  name: 'FooterOutgoingLinks',
  setup() {
    const { config: globalConfig } = useWhitelabel('global')
    const { config: portalConfig } = useWhitelabel('portal')
    const { config: signInConfig } = useWhitelabel('signIn')
    return { globalConfig, portalConfig, signInConfig, swoopLogoUrl }
  },
  data() {
    return {
      year: new Date().getFullYear()
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/styles/swoop/_variables.scss';

.app-footer {
  display: flex;
  height: 68px;
  padding: 16px;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  row-gap: 10px;
  align-self: stretch;
  flex-wrap: wrap;
  border-top: 1px solid #ebebeb;
  background-color: #ffffff;
  box-sizing: border-box;

  // Drop on tablet/mobile per design.
  @media only screen and (max-width: $breakpoint-sm-max) {
    display: none;
  }
}

.footer-copyright,
.footer-links .footer-link {
  color: #666666;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.4px;
}

.footer-links {
  display: flex;
  gap: 24px;

  .footer-link {
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
}

.footer-powered-by {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 2px;

  .powered-by-text {
    color: #666666;
    font-size: 8px;
    font-weight: 400;
    line-height: 1;
    letter-spacing: -0.2px;
  }

  .powered-by-logo {
    height: 24px;
    width: auto;
    display: block;
  }
}
</style>
